import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWalletsV2 } from 'services/WalletsService'
import { TWalletType } from 'types/wallets'

export const useWalletsQueryV2 = ({
  walletType,
  searchTerm,
  offset,
  max,
  order,
  sort,
  enabled = true,
  includeEmbedded = false,
}: {
  walletType: TWalletType
  searchTerm?: string
  offset?: number
  max?: number
  order?: string
  sort?: string
  enabled?: boolean
  includeEmbedded?: boolean
}) => {
  return useQuery({
    queryKey: reactQueryKeys.walletsV2(
      walletType,
      searchTerm,
      offset,
      max,
      order,
      sort,
      includeEmbedded
    ),
    queryFn: () => getWalletsV2(walletType, searchTerm, offset, max, order, sort, includeEmbedded),
    enabled,
  })
}
